
document.addEventListener('DOMContentLoaded', function() {
    const alertBar = document.querySelector('.c-alert-bar');
    const closeButton = document.querySelector('.js-close-alert-bar');

    function disableAlertBar() {
        if (alertBar) {
            alertBar.classList.add('is-disabled');
            localStorage.setItem('display_alert_bar', 'false');
        }
    }

    if (localStorage.getItem('display_alert_bar') === 'false' && alertBar) {
        alertBar.classList.add('is-disabled');
    }

    if (closeButton) {
        closeButton.addEventListener('click', disableAlertBar);
    }
});


function setAlertBarHeight() {

	const alertBar = document.querySelector('.c-alert-bar');
	let height = '10rem';

	if (alertBar) {
		height = `${alertBar.offsetHeight}px`;
	}

	document.documentElement.style.setProperty('--alert-bar-height', height);
}

document.addEventListener('DOMContentLoaded', setAlertBarHeight);

window.addEventListener('resize', function() {
    clearTimeout(window.resizedFinished);
    window.resizedFinished = setTimeout(setAlertBarHeight, 250);
});

document.addEventListener('DOMContentLoaded', function() {

 	const alertBar = document.querySelector('.c-alert-bar--non-sticky');

	function handleScroll() {
		if (!alertBar) return;

		const alertBarHeight = alertBar.offsetHeight;
		const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

		if (scrollPosition > alertBarHeight + 60) {
			alertBar.classList.add('is-hidden');
		} else {
			alertBar.classList.remove('is-hidden');
		}
	}
	
	window.addEventListener('scroll', handleScroll);
});